import { createSlice } from "@reduxjs/toolkit";

// Pickup locations are keyed by name (WooCommerce core's own pickup-location
// option has no stable id -- see PickupLocationSettingRepository), unlike
// every other list-of-items reducer in this app, so this doesn't reuse the
// shared getItem()/getItemIndex() utils (those hardcode matching on `.id`).
export const theSlice = createSlice({
  name: 'pickup-location-settings',
  initialState: {
    list: [],
    loaded: false,
  },
  reducers: {
    loadPickupLocationSettings: (state, action) => {
      const data = action.payload;
      state.list = data;
      state.loaded = true;
    },
    updatePickupLocationSetting: (state, action) => {
      const {name, data} = action.payload
      const item = state.list.find(item => item.name === name);
      if (item) {
        Object.assign(item, data);
      }
    },
  }
});

export const {
  loadPickupLocationSettings,
  updatePickupLocationSetting,
} = theSlice.actions;
export default theSlice.reducer;
